import { appStore } from "entities/App";
import { useSearchQuery, UseSearchQueryReturnType } from "entities/RoadSearchCard";
import { RoadSearchRequestFunc } from "entities/RoadSearchCard";
import { subscriptionStore } from "entities/Subscription";

type UseRoadSearchReturnType = {
  roadSearchRequest: RoadSearchRequestFunc;
  roadSearchResponse: UseSearchQueryReturnType["searchResponse"];
  isRoadSearchLoading: boolean;
  isRoadSearchSuccess: boolean;
  isRoadSearchError: boolean;
};

export const useRoadSearch = ({ isAuthenticated }: { isAuthenticated: boolean }): UseRoadSearchReturnType => {
  const { searchRequest, searchResponse, isSearchSuccess, isSearchError, isSearchLoading } = useSearchQuery({
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });

  return {
    roadSearchRequest: searchRequest,
    roadSearchResponse: searchResponse,
    isRoadSearchLoading: isSearchLoading,
    isRoadSearchSuccess: isSearchSuccess,
    isRoadSearchError: isSearchError,
  };
};
